import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import PropTypes from "prop-types";

import FunctionButton from "../../../../utilities/Buttons/FunctionButton";
import IconButton from "../../../../utilities/Buttons/IconButton";
import {ICON_NAMES} from "../../../../utilities/generalConstants.js/generalConstants";
import ToolTip from "../../../../utilities/ToolTip";
import useRoutePermissions, {
  UI_PERMISSION_TYPE,
} from "../../../adminForms/Ba3aSettings/tabs/PositionsSettings/useRoutePermissions";
import Modal from "../../../Modal/Modal";
import Spinner from "../../../spinner/Spinner";

import FileInput from "./utils/fileInp";
import PdfPreviewItem from "./utils/PdfPreviewItem";

// pdfMake поддерживает только .jpeg/.jpg и .png форматы картинок!

const PdfFilePreview = ({
  files,
  addFunc,
  delFunc,
  restoreFunc,
  disabled,
  accept = ".pdf",
  loading = false,
  tooltipMessage = "Add document",
  singleFile = false,
  showPdfPreview = true,
  classNameIcon,
  classNameBtn,
  widthIcon, //default 22
  heightIcon, //default 22
  bottomTooltip = false,
  onClose = () => {},
  isIconChangedIfFileUploaded = true,
  uiPermissionType = UI_PERMISSION_TYPE.WRITABLE,
}) => {
  const {t} = useTranslation();

  const {isDisabledByRoutePermission} = useRoutePermissions({uiPermissionType});

  const [modal, setModal] = useState(false);

  function renderBoxes(fileList, delFunc) {
    if (!fileList) return;

    return fileList.map((file, i) => {
      return (
        <div key={i}>
          <PdfPreviewItem
            file={file}
            delFunc={delFunc}
            restoreFunc={restoreFunc}
            showPdfPreview={showPdfPreview}
            uiPermissionType={uiPermissionType}
          />
        </div>
      );
    });
  }

  const handleDragOver = e => {
    e.preventDefault();
  };

  const handleDrop = e => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files);
    addFunc(droppedFiles);
  };

  const filesRender = renderBoxes(files, delFunc);

  const isDocumentAdded = files?.length;
  const nameIcon = isDocumentAdded && isIconChangedIfFileUploaded ? ICON_NAMES.PAPER_CLIP : ICON_NAMES.UPLOAD_CLOUD;

  return (
    <>
      <IconButton
        ariaLabel="Upload file"
        nameIcon={nameIcon}
        classNameIcon={classNameIcon}
        classNameBtn={classNameBtn}
        heightIcon={heightIcon}
        widthIcon={widthIcon}
        bottomTooltip={bottomTooltip}
        tooltipMessage={isDocumentAdded ? "Document added" : tooltipMessage}
        disabled={disabled}
        onClick={() => {
          setModal(true);
        }}
        uiPermissionType={uiPermissionType}
      />

      <Modal active={modal} setActive={setModal}>
        <div className="imgPreview">
          <div className="pb0_5">{`${t("Symbols not acceptable in file name:")} #...`}</div>
          <div className="previewBox" style={{position: "relative"}} onDragOver={handleDragOver} onDrop={handleDrop}>
            {loading ? (
              <Spinner />
            ) : (
              <>
                {filesRender}
                {!isDisabledByRoutePermission && (!singleFile || (singleFile && files?.length === 0)) && (
                  <div className="previewBoxItem img-adding">
                    <ToolTip title={isDocumentAdded ? "Document added" : "Add document"}>
                      <FileInput
                        accept={accept}
                        name="fileInput"
                        addFunc={addFunc}
                        uiPermissionType={uiPermissionType}
                      />
                    </ToolTip>
                  </div>
                )}
              </>
            )}
          </div>
          <div className="imgPreview__buttons">
            <FunctionButton
              name={t("Close")}
              onClick={() => {
                setModal(false);
                onClose();
              }}
              uiPermissionType={UI_PERMISSION_TYPE.READABLE}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

PdfFilePreview.propTypes = {
  files: PropTypes.array,
  addFunc: PropTypes.func,
  delFunc: PropTypes.func,
  disable: PropTypes.bool,
  accept: PropTypes.string,
  loading: PropTypes.bool,
};

export default PdfFilePreview;
